import { Button, EmptyState } from '@mgrvtechgroup/admin-ds';
import { CompassIcon } from 'lucide-react';
import { Link } from 'react-router';

export function NotFoundPage() {
  return (
    <div className="flex h-full flex-col items-center justify-center gap-4">
      <h1 className="title-lg text-center">페이지를 찾을 수 없습니다</h1>
      <EmptyState
        icon={CompassIcon}
        title="주소를 확인하거나 홈으로 이동해 주세요"
        description="주소가 바뀌었거나 아직 만들지 않은 화면입니다."
        className="h-auto min-h-0"
      />
      <Button nativeButton={false} role="link" render={<Link to="/" />}>
        홈으로
      </Button>
    </div>
  );
}
